import { Fragment } from "react";
import { _t } from "core/language";
import { type IRecipeDetail } from './../../store/types'
import HowToCookLoading from './Loading'

const HowToCook = ({recipe, loading}: {recipe: IRecipeDetail, loading: boolean}) => {

  return (
    <div>
      <div className="mb-3.5">
        <label className="text-dark font-medium text-base">
          {_t('recipe.how_to_cook')}
        </label>
      </div>
      <div className="flex flex-col gap-2.5">
        {loading ? (
          Array.from(Array(3).keys()).map((e: number) =>
            <Fragment key={e}><HowToCookLoading /></Fragment>
          )
        ) : (
          recipe.content?.step?.map((step: any, key: number) => (
            <div
              key={key}
              className="rounded-lg bg-[#FFFAEE] px-3.5 py-5 tex-dark text-sm"
            >
              <label className="font-medium text-[13px] mb-[8px] block">
                <span>{key + 1}.</span> <span>{step.name}</span>
              </label>
              <div className="ml-5 font-normal">
                {step.detail.length > 0 ? (
                  <ul className="list-disc">
                    {step.detail.map((detail: any, key: number) => (
                      <li className="text-[#333333] text-[13px]" key={key}>{detail}</li>
                    ))}
                  </ul>
                ) : (
                  step.detail.map((detail: any, key: number) => 
                    <div key={key}>{detail}</div>
                  )
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default HowToCook
